/**
 * ナビゲーション翻訳 - 日本語
 * Navigation translations - Japanese
 */

export default {
  home: 'ホーム',
  coreService: 'コアサービス',
  industrySolutions: '業界ソリューション',
  caseStudies: '事例紹介',
  resourceCenter: 'リソースセンター',
  customerSupport: 'カスタマーサポート',
  about: '会社概要',
  contact: 'お問い合わせ',
  search_placeholder: '技術的な質問がございますか？当社のAIエンジンがお手伝いします。'
}

